import Vue from 'vue'
import './plugins/fontawesome'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './permission'


import '@/style/main.scss'


Vue.config.productionTip = false


new Vue({
  router,
  store,
  created(){
    //页面刷新时将vuex信息保存到sessionstore中
    window.addEventListener('beforeunload',()=>{
      sessionStorage.setItem('store',JSON.stringify(this.$store.state));
    });

    //页面加载时读取sessionstore中的信息，设置到vuex中
    if(sessionStorage.getItem('store')){
      this.$store.replaceState(Object.assign({},this.$store.state,JSON.parse(sessionStorage.getItem('store'))))
    }

  },
  render: h => h(App)
}).$mount('#app')
